import { isAxiosError } from 'axios';
/**
 * Extracts error message from API error response
 *
 * @param error - The error object from API call
 * @param defaultMessage - Default message if no specific error found
 * @returns Extracted or default error message
 */ export function extractErrorMessage(error, defaultMessage) {
    if (isAxiosError(error)) {
        if (error.response) {
            var _error_response_data;
            return ((_error_response_data = error.response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.errorMessage) || defaultMessage;
        }
        if (error.request) {
            return 'Network error: Please check your internet connection and try again.';
        }
    }
    return defaultMessage;
}
